//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    loadRelation
} from "@/assets/api/dataBase.js";
import dbmap from '@/assets/dbs/hashmap.js'
import VueQr from 'vue-qr'
import axios from 'axios'
import text from '@/assets/api/text.json'
export default {
    data () {
        return {
            linkPeopleList:[],
            config: {
                value: '',
            },
            textList:[],
            productCode:""
        }
    },
   filters: {
        nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter(val){
           if(val == '1'){
                return val = '共同借款人'
            }else if(val == '2'){
                return val = '担保人'
            }else if(val == '3'){
                return val = '其他关联人'
            }else if(val == '4'){
                return val = '借款申请主体法定代表人'
            }else if(val == '5'){
                return val = '借款申请主体实际控制人'
            }else if(val == '6'){
                return val = '个人保证担保人'
            }else if(val == '7'){
                return val = '个人抵押担保人'
            }else if(val == '8'){
                return val = '个人保证担保人配偶'
            }else if(val == '9'){
                return val = '个人抵押担保人配偶'
            }else if(val == '10'){
                return val = '其他'
            }else{
                return '--'
            }
        },
        identityFilter(val){
            if(val == '1'){
                return val = '配偶'
            }else if(val == '2'){
                return val = '朋友'
            }else if(val == '7'){
                return val = '朋友配偶'
            }else if(val == '3'){
                return val = '亲戚'
            }else if(val == '8'){
                return val = '亲戚配偶'
            }else if(val == '4'){
                return val = '其他'
            }else if(val == '5'){
                return val = '合伙人'
            }else if(val == '6'){
                return val = '合伙人配偶'
            }else{
                return '--'
            }
        }
    },
    created(){
        this.getProductCodeFun();
    },
    mounted(){
        this.getloadRelation()
    },
    methods:{
        getProductCodeFun(){
            let url =  process.env.BASE_API2 +'getProductCode'

            axios({
                method: 'post',
                url: url,
                data: {}
            }).then((res)=>{
                 if(res.data.responseCode === '000000'){
                    this.productCode = res.data.responseData.productCode;
                    if(this.productCode === '6000'){
                        this.config.value = `${window.location.origin}/#/certified?loanOrderCode=${this.$route.query.loanOrderCode}`
                        let a = document.getElementById('qrUrl').getElementsByTagName("img")
                        a[0].alt = this.config.value;
                    }
                    
                    text.map((item, index) => {
                        if(this.productCode === item.code){
                            this.textList = item;
                            return
                        }
                        return
                    });
                 }
              
            })
       
        },
        getloadRelation() {
            loadRelation({}).then(result => {
                if (result.responseCode === "000000") {
                    let retsult = result.responseData
                    this.linkPeopleList = retsult.relationList
                }
            });
        },
        editBack(){
            this.$router.push("/editPerson")
        },
        copyQrUrl(){
            let input = document.getElementById('textarea')
            input.value = this.config.value
            input.select()
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block'
            setTimeout(()=>{
                document.getElementById('showTips').style.display = 'none'
            },2000)
        }
    },
    components:{
        VueQr
    }
}




// WEBPACK FOOTER //
// ./src/view/editAgain.vue